<template>
  <div>
    <PageHeader title="Player of the match selection"></PageHeader>
    <v-container class="pa-0">
      <v-row>
        <v-col>
          <div v-if="pageReady">
            <v-container class="pa-0 mb-4">
              <v-row>
                <v-col cols="1">
                  <ClubIcon 
                  :name="competition.ownTeamName"
                  :shield="competition.ownClubShield"
                  :ball="competition.ownClubBallColour"
                  ></ClubIcon>
                </v-col>
                <v-col cols="11" class="pt-4 pl-5">{{competition.ownTeamName}}</v-col>
              </v-row>
            </v-container>
          </div>
          <v-radio-group 
            v-model="playerOfTheMatchId"
          >
            <v-card
              outlined
              v-for="matchPlayer in matchPlayers" :key="matchPlayer.id"
              class="mb-4"
            >
              <v-list-item>
                <v-list-item-content>
                  <v-container class="pa-0">
                    <v-row>
                      <v-col cols="2">
                        <img :src="matchPlayer.photoUrl" :alt="matchPlayer.playerName" style="height: 35px;">
                      </v-col>
                      <v-col cols="8">
                        <div>{{matchPlayer.playerName}}</div>
                        <div class="small-text mt-1">{{matchPlayer.positionName}}</div>
                      </v-col>
                      <v-col cols="2">
                        <v-radio
                          class="mt-1 player-voting-radio"
                          :value="matchPlayer.playerId"
                        ></v-radio>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <router-link :to="{name: 'entry-home', query: {entryId: $route.query.entryId}}">Back to entry home</router-link>
        </v-col>
      </v-row>
    </v-container>
    <v-overlay
      :absolute="false"
      :value="overlay"
      :opacity="0.9"
      >
      <v-progress-circular
        indeterminate
        color="amber"
        :size="70"
        :width="7"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import PageHeader from './../../components/PageHeader';
import ClubIcon from './ClubIcon';
import axios from 'axios';
import Socket from "./../../plugins/socket";

export default {
  name: 'voting',
  components: {
    PageHeader,
    ClubIcon
  },
  data: () => ({
    matchPlayers: null,
    entry: null,
    competition: null,
    playerOfTheMatchId: null,
    overlay: false,
    requiredUpdates: 2,
    updatesReceived: 0
  }),
  computed: {
    pageReady () {
      return this.entry !== null && 
      this.matchPlayers !== null && 
      this.competition !== null;
    },
    updatingWalletHoneyPoints () {
      return this.$store.getters.updatingWalletHoneyPoints;
    },
    updatingEntry () {
      return this.$store.getters.updatingEntry;
    }
  },
  methods: {
    reconnect: function () {
      var scope = this;
      console.log('Connectionid is null when voting, must get new one.');
      Socket.connect(scope.$store.getters.userSub.userName);
      setTimeout(() => {
        scope.submitVote();
      }, 2500);
    },
    getMatchPlayers: function () {
      var scope = this;
      this.$store.dispatch('getMatchPlayers', this.$route.query.matchId).then(getMatchPlayersResponse => {
        scope.matchPlayers = getMatchPlayersResponse;
        scope.getEntry();
      }, error => {
          console.log(error);
      });
    },
    getEntry: function () {
      var scope = this;
      this.$store.dispatch('getEntry', this.$route.query.entryId).then(getEntryResponse => {
        scope.entry = getEntryResponse;
        scope.getCompetition(scope.entry.competitionId);
      }, error => {
          console.log(error);
      });
    },
    getCompetition: function (competitionId) {
      var scope = this;
      this.$store.dispatch('getCompetition', competitionId).then(getCompetitionResponse => {
        scope.competition = getCompetitionResponse;
        scope.overlay = false;
      }, error => {
          console.log(error);
      });
    },
    submitVote: function () {
      this.overlay = true;
      var scope = this;

      if(scope.$store.getters.connectionId === null){
        scope.reconnect();
        return;
      }

      axios.post(`https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/entry-votes`, {
        entryId: scope.entry.id,
        playerId: scope.playerOfTheMatchId
      }, {
        headers: {
          'Authorization': localStorage.getItem('jwtToken')
        }
      })
        .then(function () {
          scope.$store.commit('setUpdatingEntry', 1);
          axios.put(`https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/entries/${scope.entry.id}`, {
            voted: true
          }, {
            headers: {
              'Authorization': localStorage.getItem('jwtToken'),
              connectionid: scope.$store.getters.connectionId
            }
          })
            .then(function () {
              scope.$store.commit('setUpdatingWalletHoneyPoints', 1);
              var slug = "selected-player"
              axios.post('https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/honey-transactions', {
                userId: scope.$store.getters.userSub.id,
                walletId: scope.$store.getters.wallet.id,
                entryId: scope.entry.id,
                isDebit: false,
                honeyPointSlug: slug
              }, {
                headers: {
                  Authorization: localStorage.getItem('jwtToken'),
                  connectionid: scope.$store.getters.connectionId
                }
              })
                .then(function () {

                })
                .catch(function (error) {
                  console.log(error);
                });
              
            })
            .catch(function (error) {
              console.log(error);
            });

        })
        .catch(function (error) {
          console.log(error);
        });
    },
    updateWallet(){
      var scope = this;
      this.$store.dispatch('getWallet', this.$store.getters.userSub.id).then(response => {
          scope.$localStorage.set('wallet', JSON.stringify(response));
          scope.$store.commit('setWallet', response);
          scope.$store.commit('setUpdatingWalletHoneyPoints', 0);
          scope.$store.commit('setUpdatingEntry', 0);
          scope.overlay = false;
          scope.$router.push({name: 'entry-home', query: { 
            entryId: scope.entry.id
          }});
        }, error => {
            console.log(error);
        })
    }
  },
  created () {
    this.overlay = true;
    this.getMatchPlayers();
  },
  watch: {
    updatingEntry (newVal) {
      console.log('updatingEntry ' + newVal);
      if(newVal === 2)
        this.updatesReceived++;
    },
    updatingWalletHoneyPoints (newVal) {
      console.log('updatingWalletHoneyPoints ' + newVal);
      if(newVal === 2)
        this.updatesReceived++;
    },
    updatesReceived (newVal) {
      console.log('required updates: ' + this.requiredUpdates);
      console.log('updates received: ' + newVal);
      if(this.requiredUpdates === newVal)
        this.updateWallet();
    },
    playerOfTheMatchId () {
      this.submitVote();
    }
  }
}
</script>